import SelectComponent from '@componentes/select/select.component';
import React from 'react';
import { Row, Col, FormGroup, Label, Input, Card, CardBody, CardTitle, CardText } from 'reactstrap';

const ProtocoloMacroscopiaPage = (props) => (
    <div>
        <Row>
            <Col>
                <FormGroup>
                    <Label>Bloco:</Label>
                    <SelectComponent options={props.blocos.map(bloco => {
                        return {
                            value: bloco.id,
                            label: bloco.numeroBloco
                        }
                    })} placeholder="Selecionar bloco" onChange={(e) => { props.onBlocoChange(e.label) }} />
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <Label>Protocolo:</Label>
                    <SelectComponent options={props.protocolo} placeholder="Selecionar Protocolo" onChange={(e) => { props.onProtocoloChange(e.label) }} />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col>
                <FormGroup>
                    <Label>Observações</Label>
                    <Input type="textarea" />
                </FormGroup>
            </Col>
        </Row>
        <Row>
            <Col>
                {
                    props.laminas.map(lamina => {
                        return (
                            <Row key={lamina.id}>
                                <Col>
                                    <Card>
                                        <CardBody>
                                            <CardTitle>{`04/05/2018 - Bloco ${lamina.bloco}`}</CardTitle>
                                            <CardText>{lamina.protocolo}</CardText>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        )
                    })
                }
            </Col>
        </Row>
    </div>
)

export default ProtocoloMacroscopiaPage;


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/protocolo/protocolo.page.js